// CONFIG
const maxHistorylength = 24;
const expiration = 60; // Days;

const storageKey = 'historyNavigation';
const separator = ',';
export default class NavigationHistory {
  constructor() {
    this.currentRef = document.querySelector('.js-product-ref') && document.querySelector('.js-product-ref').innerText;
    if (this.currentRef) {
      lm.localStorageLM.init();
      this.save();
    }
  }
  save() {
    const currentHistory = lm.localStorageLM.get(storageKey).split(separator).filter(ref => ref !== '');

    // remove doublons
    const existingRefIndex = currentHistory.indexOf(this.currentRef);
    if (existingRefIndex >= 0) {
      currentHistory.splice(existingRefIndex, 1);
    }

    // Remove oldest refs if history is full
    if (currentHistory.length >= maxHistorylength) {
      currentHistory.pop();
    }
    currentHistory.unshift(this.currentRef);
    const newHistory = currentHistory.join(separator);
    lm.localStorageLM.set(storageKey, newHistory, expiration);
  }
}